module.exports = __webpack_public_path__ + "static/media/quindio-73.1a32cc83.jpg";